<template lang="pug">
.flex.gap-0.gap-2
    .flex.self-center.gap-2
        UDropdownMenu(
            :items="items"
            :ui="{content: 'bg-white w-56'}"
        )
            UBadge.rounded-full.px-1.flex.self-center.gap-2(
                :ui="{base: 'text-sm'}"
                class="cursor-pointer"
                color="secondary"
                variant="soft"
                size="xs"
            )
                .flex.self-center
                    UAvatar.rounded-full(
                        size="xs"
                        src="https://lh3.googleusercontent.com/a-/AFdZucplMj5mkuvUjMjaqMYiZByYJjtj0Xu3dJZR8WJY=s96-c"
                    )
                .flex.self-center.pr-2.text-xs
                    .text-ellipsis.truncate {{ authData?.fullname }}
                    | &nbsp;/ {{ authData?.role }}

            template(#profile)
                .flex.flex-1.gap-3(
                    v-if="authData?.id"
                )
                    .flex.self-center
                        UAvatar.rounded-sm(
                            size="sm"
                            :src="authData?.avatar ?? `https://aimvatar.aimi.workers.dev/${authData?.fullname}`"
                        )
                    .flex-col.justify-start
                        .flex.self-center.text-xs.truncate {{ authData?.email }}
                        .flex.self-center.pt-1
                            UBadge.rounded-full.px-2(
                                size="sm"
                                color="secondary"
                                variant="subtle"
                                :label="authData?.role"
                            )
</template>

<script setup lang="ts">
const colorMode = useColorMode();
const authData = useState("auth");

const isDark = computed({
  get() {
    return colorMode.value === "dark";
  },
  set() {
    colorMode.preference = colorMode.value === "dark" ? "light" : "dark";
  },
});

const items = computed(() => [
  [
    {
      label: "profile",
      avatar: {
        size: "xs",
      },
      type: "label",
      slot: "profile",
    },
  ],
  [
    {
      label: "Profile",
      icon: "i-lucide-user",
      kbds: ["P"],
      to: "/profile",
    },
    {
      label: "Settings",
      icon: "i-lucide-cog",
      kbds: ["S"],
      to: "/settings",
    },
    {
      label: ` ${colorMode.preference === "light" ? "Dark" : "Light"} Mode`,
      icon: colorMode.preference === "light" ? "i-lucide-moon" : "i-lucide-sun",
      onSelect() {
        colorMode.preference = colorMode.value === "dark" ? "light" : "dark";
      },
      onClick: () => {
        colorMode.preference = colorMode.value === "dark" ? "light" : "dark";
      },
      /// kbds: ['shift', 'meta', 'd'],
    },

    // {
    //     label: 'Support',
    //     icon: 'i-lucide-life-buoy',
    //     to: '/components/dropdown-menu',
    // },
  ],
  [
    {
      label: "Logout",
      icon: "i-lucide-log-out",
      to: "/logout",
      // kbds: ['shift', 'meta', 'q'],
    },
  ],
]);
</script>
